export default class Consumer {
    constructor(json) {
        json = json || {};
        this.id = json.id || '';
        this.type = json.type || '';
        this.identifier = json.identifier || '';
        this.first_name = json.first_name || '';
        this.last_name = json.last_name || '';
        this.email = json.email || '';
        this.phone = json.phone || '';
        this.contact_id = json.contact_id || '';
    }
}